import { render } from "./Create.vue?vue&type=template&id=4e50318f"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Employees/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e50318f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e50318f', __exports__)) {
    console.log('reload')
    api.reload('4e50318f', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=4e50318f", () => {
    console.log('re-render')
    api.rerender('4e50318f', render)
  })

}


export default __exports__